<div *ngIf="loaded; else loading">

  <div *ngIf="updateRateObj.data.number_of_waiting_updates === 0; else pendingChanges">

    <div class="card">
      <h2>Rate Change Tool</h2>
      <p>Use this tool to update rates for all monthly invoice profiles at {{ updateRateObj.data.locationID }} - {{ updateRateObj.data.locationName }}.</p>

      <div class="form-field">
        <label for="old-rate">Old Rate to Update</label>
        <p-autoComplete
          id="old-rate"
          [(ngModel)]="oldRate"
          [suggestions]="filteredOldRates"
          (completeMethod)="filterOldRates($event)"
          field="name"
          dataKey="code"
          placeholder="Type to search for a rate to replace"
          [dropdown]="true"
          [forceSelection]="true"
          [inputStyle]="{'width':'350px'}">
          <ng-template let-rate pTemplate="item">
            {{ rate.name }}
          </ng-template>
        </p-autoComplete>
      </div>

      <div class="form-field">
        <label for="new-rate">New Rate</label>
        <p-autoComplete
          id="new-rate"
          [(ngModel)]="newRate"
          [suggestions]="filteredNewRates"
          (completeMethod)="filterNewRates($event)"
          field="name"
          dataKey="code"
          placeholder="Type to search for the replacement rate"
          [dropdown]="true"
          [forceSelection]="true"
          [inputStyle]="{'width':'350px'}">
          <ng-template let-rate pTemplate="item">
            {{ rate.name }}
          </ng-template>
        </p-autoComplete>
      </div>

      <div class="form-actions">
        <p-button
          label="Update Rate"
          icon="pi pi-check"
          (click)="updateRate()"
          [disabled]="formSubmitted">
        </p-button>
      </div>

      <div *ngIf="formErrors !== ''" class="form-error">
        <i class="pi pi-exclamation-triangle"></i> {{formErrors}}
      </div>
      <div *ngIf="formNotice !== ''" class="form-notice">
        <i class="pi pi-info-circle"></i> {{formNotice}}
      </div>
    </div>

  </div>

</div>

<ng-template #loading>
  <div class="loading-container">
    <p-progressSpinner></p-progressSpinner>
    <p>Loading rate data...</p>
  </div>
</ng-template>

<ng-template #pendingChanges>
  <div class="card warning-card">
    <i class="pi pi-exclamation-circle" style="font-size: 2rem;"></i>
    <h3>Updates In Progress</h3>
    <p>
      Rates cannot be updated at this time.
      {{updateRateObj.data.number_of_waiting_updates}} rate(s) are still being updated.
    </p>
    <p>Please wait for the previous changes to complete and then try again.</p>
  </div>
</ng-template>
